export default "__VITE_ASSET__ypxPbfbY__"